import React, { useState, useEffect, useRef } from "react";
import queryString from 'query-string';
import { Form } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'ice';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Form onSubmit={event => onSubmit(event)} className='ice-form'>
          <label className="ice-label">{translate("PlaceholderUserName")}</label>
          <input
            className='ice-input'
            disabled={onLogin}
            onChange={e => setUsername(e.target.value)}
            required={true}
            tabIndex={1}
            type="text"
            autoCorrect="off"
            autoCapitalize="none"
            name="username"
          />
          <label className="ice-label">{translate("PlaceholderPassword")}</label>
          <input
            className='ice-input'
            required={true}
            disabled={onLogin}
            onChange={e => setPassword(e.target.value)}
            tabIndex={1}
            type="password"
            autoCorrect="off"
            autoCapitalize="none"
            name="password"
          />
          <div className="buttons">
            <button
              className="ice-button"
              block={!parameters.failureRedirect}
              tabIndex={1}
              type="submit"
              name="submit"
              disabled={!props.turnstileSuccess}
            >
              {translate('Entrar')}
            </button>
            <a href="https://apps.grupoice.com/AVWeb/OlvideContrasenaKHTV.do?view=1" className="linksLogin">{translate("ForgotPassword")}</a>
            {checkDeviceIOS() ? '' : <a href="https://apps.grupoice.com/AVWeb/AgregarKHTVCuentaFOX.do" className="linksLogin">{translate("RegisterAccount")}</a>}
          </div>
          <div className='ice-error-container'>
            <strong className='ice-error-msg'>{error.message} </strong>
          </div>
          <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginBottom: '2rem' } });
